<template>
  <div class="ComboboxComponent">
    
    <!-- <v-select size="sm" :options="actions" :taggable="true" :placeholder="lang.placeholder" v-model="filterText">
    </v-select> -->
    <b-dropdown id="dropdown-actions" :text="lang.placeholder" class="m-md-2 actionButtonFolder" size="sm" :variant="variant">
      <b-dropdown-item @click="selectAction(action.actionId)" :id="'action_' + action.actionId" v-for="action in idActions" :key="action.actionId">{{ action.name }}</b-dropdown-item>
      
    </b-dropdown>
 </div>
</template>

<script>

//import vSelect from 'vue-select'
export default {
  name: 'ComboboxComponent',
  components: {
    //vSelect
  },
  props:{
    lang: Object
  },
  data () {
    return {
      list: [''],
      filterText: "",
      actions: [""],
      idActions: []
    }
  },
  computed: {
    
    actionsList() {

      return this.$store.getters.filters
    },
    variant() {
      if (this.$store.getters.s_skinVariant == "dark") {
        return "light";
      } else {
        return "dark";
      }

    },
  },
  created () {
    
    let vue = this;

    this.$store.dispatch(this.$store.getters.sectionPrefix + '_getActions')
      .then((result) => {
        console.log(result)
        if (result.status == "OK"){

          vue.buildActionsList(result.data);
        }
      })
    
    
  },
  updated() {
    
    
  },
  watch: {
    
  },
  methods: {
    selectAction(actionId) {
      

      for (var i = 0, len = this.idActions.length; i < len; i++) {

        if (this.idActions[i].actionId == actionId) {

          

          this.$store.dispatch(this.$store.getters.sectionPrefix + "_addActiveFilter", this.idActions[i].name);
          this.$store.dispatch(this.$store.getters.sectionPrefix + "_addActiveAction", this.idActions[i]);

        }
      }

    },
    compare(a, b) {
      if (a.priority > b.priority) return 1;
      if (b.priority > a.priority) return -1;

      return 0;
    },
    buildActionsList(data){
      
      data.sort(this.compare)

      
      
      for(let i = 0, lei = data.length; i < lei; i++){

        this.actions.push(data[i].name)
        this.idActions.push(data[i])

        
      }

    },
    
  }
}
</script>


<style lang="scss">
  .ComboboxComponent{
    .clear{
      display: none;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/shared/ComboboxComponent.vue